import { FC, MutableRefObject, useEffect, useRef, useState } from 'react';
import { AText, Box, Popover } from '@alf/uikit';
import { useI18n } from '@namespace/i18n';
import { Icon } from '@namespace/icons2';

import styles from './index.module.css';

interface TransactionStatusPopoverProps {
  title: string;
  description: string[] | (string | string[])[];
  wrapperRef: MutableRefObject<HTMLDivElement>;
}

export const TransactionStatusPopover: FC<TransactionStatusPopoverProps> = ({
  title,
  description,
  wrapperRef
}) => {
  const [isPopoverOpen, setIsPopoverOpen] = useState(false);

  const contentRef = useRef<HTMLDivElement>();
  const arrowRef = useRef<HTMLDivElement>();

  const { t } = useI18n();

  useEffect(() => {
    if (isPopoverOpen) {
      const contentRect = (
        contentRef as MutableRefObject<HTMLDivElement>
      ).current.getBoundingClientRect();
      const tabelCellRect = (
        wrapperRef.current.parentElement as HTMLElement
      ).getBoundingClientRect();

      const contentWidth = (contentRef as MutableRefObject<HTMLDivElement>)
        .current.clientWidth;
      const contentOffsetX = contentRect.left - tabelCellRect.left;

      const isContentIsToLong = contentWidth / 2 < contentOffsetX;

      const contentTranslateX = isContentIsToLong
        ? `calc(-50% + 12px)`
        : `-${contentOffsetX}px`;

      const arrowLeftPosition = isContentIsToLong
        ? '50%'
        : `${contentOffsetX + 12}px`;

      const { parentElement } = contentRef.current as HTMLDivElement;

      if (parentElement) {
        parentElement.style.transform = `translateX(${contentTranslateX})`;
        (arrowRef as MutableRefObject<HTMLDivElement>).current.style.left =
          arrowLeftPosition;
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isPopoverOpen, t]);

  return (
    <Popover
      isOpenExternal={isPopoverOpen}
      setIsOpenExternal={setIsPopoverOpen}
      classNames={{
        wrapperClass: styles.popoverWrapper,
        contentClass: styles.popoverContentWrapper
      }}
      trigger={
        <Box left="xs">
          <Icon
            className={styles.icon}
            name="icons/general/state/info2"
            color="state_info"
            size="s"
          />
        </Box>
      }
      content={
        <Box
          ref={contentRef as MutableRefObject<HTMLDivElement>}
          direction="column"
          padding="xs s"
        >
          <AText breed="B" size="s">
            {t(title)}
          </AText>

          {description && (
            <AText
              className={styles.description}
              size="s"
              dangerouslySetInnerHTML={{
                __html: t(...description)
              }}
            />
          )}

          <div
            ref={arrowRef as MutableRefObject<HTMLDivElement>}
            className={styles.arrow}
          />
        </Box>
      }
    />
  );
};
